<template>
    <Dialog v-model="show" @input="$listeners.input" :title="title" max-width="90vw" max-height="90vh" :show-close-button="showCloseButton"
            @close="fecharDialog">
        <div class="col justify-center">
            <div class="d-flex justify-center align-center flex-column mt-8">
                <ToolTip right content="Selecione um dos blocos abaixo para realizar a ordenação do valor do bem."
                         icon="mdi-help-circle" :icon-attrs="{ color: 'primary', size: '18px' }" label-text="Valor do Bem: "
                         text-color="text-primary" label-size="label-size"
                         :content-style="{ width: '200px', maxWidth: '200px', fontSize: '12px' }"
                         reverse-order-class="reverse-order" />

                <div class="d-flex justify-center align-center mt-1 flex-wrap">
                    <v-btn :outlined="!isSelecionado('vl_bem', 'desc')" class="mx-2 my-2" color="secondary"
                           @click="setOrdenacao('vl_bem', 'desc')">
                        Maior para Menor
                    </v-btn>
                    <v-btn :outlined="!isSelecionado('vl_bem', 'asc')" class="mx-2 my-2" color="secondary"
                           @click="setOrdenacao('vl_bem', 'asc')">
                        Menor para Maior
                    </v-btn>
                </div>
            </div>

            <div class="d-flex justify-center align-center flex-column mt-12">
                <ToolTip custom-background="custom-tooltip-bg" right
                         content="Selecione um dos blocos abaixo para realizar a ordenação do valor da parcela." icon="mdi-help-circle"
                         :icon-attrs="{ color: 'primary', size: '18px' }" label-text="Valor da Parcela:" label-size="label-size"
                         text-color="text-primary" :content-style="{ width: '200px', maxWidth: '200px', fontSize: '12px' }"
                         reverse-order-class="reverse-order" />

                <div class="d-flex justify-center align-center mt-2 flex-wrap">
                    <v-btn :outlined="!isSelecionado('menor_vl_parcela', 'desc')" class="mx-2 my-2" color="secondary"
                           @click="setOrdenacao('menor_vl_parcela', 'desc')">
                        Maior para Menor
                    </v-btn>
                    <v-btn :outlined="!isSelecionado('menor_vl_parcela', 'asc')" class="mx-2 my-2" color="secondary"
                           @click="setOrdenacao('menor_vl_parcela', 'asc')">
                        Menor para Maior
                    </v-btn>
                </div>
            </div>

            <div class="d-flex justify-end mt-4">
                <v-btn class="transition pa-6" color="primary" rounded @click="confirm">
                    Ordenar
                </v-btn>
            </div>
        </div>
    </Dialog>
</template>

<script>

  import ToolTip from './ToolTip.vue'

  export default {
    name: 'DialogOrdenarBens',
    components: {
      ToolTip
    },
    props: {
      value: { type: Boolean, default: false },
      showCloseButton: { type: Boolean, default: true }
    },
    data: () => ({
      title: 'ORDENAR lISTAGEM',
      ordenacao: {}
    }),
    computed: {
      show: {
        get () {
          return this.value
        },
        set (val) {
          this.$emit('input', val)
        }
      }
    },
    mounted () {
      this.inicializaOrdenacao()
    },
    methods: {
      fecharDialog () {
        this.show = false
      },

      inicializaOrdenacao () {
        this.ordenacao = { campo: 'vl_bem', ordem: 'desc' }
      },

      setOrdenacao (campo, ordem) {
        this.ordenacao = { campo, ordem }
      },

      confirm () {
        this.$emit('ordenar', this.ordenacao)
        this.fecharDialog()
      },

      isSelecionado (campo, ordem) {
        return this.ordenacao.campo === campo && this.ordenacao.ordem === ordem
      }

    }
  }
</script>
